import React from "react";
import userimg from "../../assets/frnds.png";

const RightList = () => {
  return (
    <div>
      {" "}
      <aside className="  w-full bg-white p-3">
        <div className="right-sidebar-fixed">
          <h3 className="followers-title mb-4">Based on Your Followers</h3>
          <div>
            {[1, 2, 3, 4].map((user) => (
              <div key={user} className="">
                <div className="flex  justify-between mt-3 items-center">
                  <div className="flex  gap-3 items-center">
                    <div className="w-[60px] h-[60px] ">
                      <img
                        src={userimg}
                        alt="User"
                        className="w-full h-full rounded-full"
                      />
                    </div>
                    <div className="">
                      <p className=" text-[16px] font-medium">
                        Marketing Group
                      </p>

                      <p className="text-[10px] text-[#ccc]">764 Followers</p>
                    </div>
                    <button className="bg-green-900 text-white px-4 py-1 text-[12px] rounded-full ">
                      Follow
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h3 className="font-semibold mt-6 mb-4">Based on Your Groups</h3>
          <div>
            {[1, 2, 3, 4].map((user) => (
              <div key={user} className="">
                <div className="flex  justify-between mt-3 items-center">
                  <div className="flex  gap-3 items-center">
                    <div className="w-[60px] h-[60px] ">
                      <img
                        src={userimg}
                        alt="User"
                        className="w-full h-full rounded-full"
                      />
                    </div>
                    <div className="">
                      <p className=" text-[16px] font-medium">
                        Marketing Group
                      </p>

                      <p className="text-[10px] text-[#ccc]">764 Followers</p>
                    </div>
                    <button className="bg-green-900 text-white px-4 py-1 text-[12px] rounded-full ">
                      Follow
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
};

export default RightList;
